<template>
  <div id="app">
    <div class="site-wrapper container-no-padding width-full
    flex flex-col align-items-start relative"
    >
      <div class="content width-xl
      grid grid-cols-12 sm-grid-cols-6 col-gap l-col-gap"
      >
        <Header />
        <Navigation />
        <main class="main col-span-9 col-start-4 row-span-1 row-start-2">
          <router-view />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/global/Header';
import Navigation from '@/components/global/Navigation';

export default {
  components: {
    Header,
    Navigation,
  },
};
</script>

<style lang="scss">
  @import '@/assets/sass/app';
</style>
